import { render, staticRenderFns } from "./pembekuan.vue?vue&type=template&id=66436714"
import script from "./pembekuan.vue?vue&type=script&lang=js"
export * from "./pembekuan.vue?vue&type=script&lang=js"
import style0 from "./pembekuan.vue?vue&type=style&index=0&id=66436714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports